// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"fc39c135","681":"1ca3baad","756":"6e93b317","787":"9171afa1"}[chunkId] + ".chunk.js";
};